import React from 'react';
//import { Link } from 'react-router-dom';
import './teambuild.css';
import { Link } from 'react-router-dom';





const Teambuild = () => {
   const handleClick = () => {
        window.scrollTo(0, 0); // Scroll to the top
    };
  
  return (
    <>
    <div className="homeabtus">
        

        <div className='homeabtusintro'>
            <div className='hmabtparasecti'>
                <h2>Team Building Activities</h2>
                <p>Silwane Tours and Safaris is proud to offer bespoke, nature-immersed team building experiences designed to forge stronger working relationships, enhance communication, and boost morale—all within the breathtaking wilderness of the Silwane Nature Reserve.</p>
                <p>Escape the confines of the office and leverage the powerful, natural environment to unlock your team's true collaborative potential.</p>
            </div>
            <Link 
              to="/gallery" 
              onClick={handleClick}
              //onClick={() => {if (window.location.href === 'http://localhost:3000/onlinecategory') {window.location.reload()} }}
              state = {{
                  data: { majorevents: "team building", abt: "" } 
              }}
              style={{ textDecoration: 'none', color: 'black' }}
            >
            <div className="hmabtbutton">
                <p>Learn More</p>
            </div>
            </Link>
        </div>
      
    </div>

    
   
    </>
  );
};
  
export default Teambuild;
  
  